import React from 'react'
import { Modal, ModalBody, Button } from 'reactstrap'

const PremiumProgressModal = ({
  isOpen,
  current,
  total,
  onCancel,
  title = 'Menyiapkan Data',
}) => {
  const [maxPercentage, setMaxPercentage] = React.useState(0)

  const rawPercentage = total > 0 ? Math.round((current / total) * 100) : 0

  // Ensure percentage is monotonic (never moves backward)
  React.useEffect(() => {
    if (isOpen) {
      setMaxPercentage((prev) => Math.max(prev, rawPercentage))
    } else {
      setMaxPercentage(0)
    }
  }, [rawPercentage, isOpen])

  const percentage = maxPercentage

  // Circular progress math
  const radius = 36
  const circumference = 2 * Math.PI * radius
  const offset = circumference - (percentage / 100) * circumference

  return (
    <Modal
      isOpen={isOpen}
      centered
      backdrop="static"
      size="sm"
      contentClassName="border-0 shadow-lg rounded-4"
    >
      <ModalBody className="p-4 d-flex flex-column align-items-center">
        <div className="position-relative mb-3" style={{ width: '100px', height: '100px' }}>
          {/* Circular Progress SVG */}
          <svg className="w-100 h-100" viewBox="0 0 100 100">
            {/* Background Circle */}
            <circle
              className="text-light"
              strokeWidth="6"
              stroke="currentColor"
              fill="transparent"
              r={radius}
              cx="50"
              cy="50"
              style={{ color: '#F2F4F7' }}
            />
            {/* Progress Circle */}
            <circle
              className="text-primary"
              strokeWidth="6"
              strokeDasharray={circumference}
              strokeDashoffset={offset}
              strokeLinecap="round"
              stroke="#005270"
              fill="transparent"
              r={radius}
              cx="50"
              cy="50"
              style={{
                transition: 'stroke-dashoffset 0.5s ease',
                transform: 'rotate(-90deg)',
                transformOrigin: '50% 50%'
              }}
            />
          </svg>
          {/* Percentage Text */}
          <div 
            className="position-absolute top-50 start-50 translate-middle text-primary fw-bold"
            style={{ fontSize: '1.2rem', color: '#005270' }}
          >
            {percentage}%
          </div>
        </div>

        <h5 className="text-dark fw-bold mb-1" style={{ fontSize: '1.05rem' }}>{title}</h5>
        <p className="text-muted small mb-4 text-center">
          Mohon tunggu sebentar, kami sedang memproses permintaan Anda.
        </p>

        <Button 
          color="light" 
          outline 
          className="w-100 rounded-pill border-0 fw-medium text-muted"
          style={{ backgroundColor: '#F9FAFB' }}
          onClick={onCancel}
        >
          Batal
        </Button>
      </ModalBody>
    </Modal>
  )
}

export default PremiumProgressModal
